<h1 mat-dialog-title>
  {{ 'HEADER.ABOUT' | translate }} {{appName}}
</h1>
<p>
  <span style="font-weight: 600;">{{ 'ABOUT.APP_VERSION' | translate }}:</span> {{appVersion}}
</p>
<p>
  <span style="font-weight: 600;">{{ 'ABOUT.API_VERSION' | translate }}:</span> {{apiVersion}}
</p>
<p>
  <span style="font-weight: 600;">{{ 'ABOUT.AUTH_VERSION' | translate }}:</span> {{authApiVersion}}
</p>
<p>
  <span style="font-weight: 600;">{{ 'ABOUT.IAM_VERSION' | translate }}:</span> {{iamApiVersion}}
</p>
